"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFormInputValidationProps = exports.useFormInputProps = exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = require("react");
var _reactUse = require("react-use");
var _formik = require("formik");
var _lodash = require("lodash");
var _HBFormProvider = require("../HBFormFields/HBFormProvider");
var _excluded = ["onBlurCallback", "onChangeCallback"],
  _excluded2 = ["onBlur", "onChange", "value"],
  _excluded3 = ["errorMessage"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useFormFieldProps = function useFormFieldProps(_ref) {
  var onBlurCallback = _ref.onBlurCallback,
    onChangeCallback = _ref.onChangeCallback,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var shouldRespectUpdateOnBlur = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var _useField = (0, _formik.useField)(props.id),
    _useField2 = (0, _slicedToArray2["default"])(_useField, 3),
    _useField2$ = _useField2[0],
    onBlur = _useField2$.onBlur,
    onChange = _useField2$.onChange,
    globalValue = _useField2$.value,
    fieldProps = (0, _objectWithoutProperties2["default"])(_useField2$, _excluded2),
    _useField2$2 = _useField2[1],
    error = _useField2$2.error,
    initialValue = _useField2$2.initialValue,
    setValue = _useField2[2].setValue;
  var _useFormContext = (0, _HBFormProvider.useFormContext)(),
    _updateOnBlur = _useFormContext.updateOnBlur;
  var updateOnBlur = shouldRespectUpdateOnBlur && _updateOnBlur;
  var _useState = (0, _react.useState)(initialValue),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    localValue = _useState2[0],
    setLocalValue = _useState2[1];
  var localValueRef = (0, _react.useRef)(localValue);
  localValueRef.current = localValue;
  var value = updateOnBlur ? localValue : globalValue;
  (0, _react.useEffect)(function () {
    if (updateOnBlur) {
      setLocalValue(globalValue);
    }
  }, [updateOnBlur, globalValue]);
  (0, _reactUse.useEvent)('keydown', function (e) {
    if (updateOnBlur && e.key === 'Enter') {
      setValue(localValueRef.current);
    }
  });
  var _onBlur = (0, _react.useCallback)(function () {
    if (updateOnBlur) {
      setValue(localValue);
    }
    // @ts-ignore
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    onBlur.apply(void 0, args);
    onBlurCallback === null || onBlurCallback === void 0 || onBlurCallback.apply(void 0, args);
  }, [updateOnBlur, localValue, onBlur, onBlurCallback, setValue]);
  var _onChange = (0, _react.useCallback)(function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    var eventOrValue = args[0];
    if (eventOrValue !== null && eventOrValue !== void 0 && eventOrValue.nativeEvent) {
      var newValue = eventOrValue.target.value;
      if (updateOnBlur) {
        setLocalValue(newValue);
      } else {
        // @ts-ignore
        onChange.apply(void 0, args);
      }
    } else {
      if (updateOnBlur) {
        setLocalValue(eventOrValue);
      } else {
        setValue(eventOrValue);
      }
    }
    onChangeCallback === null || onChangeCallback === void 0 || onChangeCallback.apply(void 0, args);
  }, [updateOnBlur, onChange, onChangeCallback, setValue]);
  return _objectSpread(_objectSpread({
    error: !!error,
    errorMessage: error,
    initialValue: initialValue,
    onBlur: _onBlur,
    onChange: _onChange,
    value: value
  }, fieldProps), props);
};
var _default = exports["default"] = useFormFieldProps;
var useFormInputProps = exports.useFormInputProps = function useFormInputProps(props) {
  var shouldRespectUpdateOnBlur = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var _useFormFieldProps = useFormFieldProps(props, shouldRespectUpdateOnBlur),
    errorMessage = _useFormFieldProps.errorMessage,
    inputProps = (0, _objectWithoutProperties2["default"])(_useFormFieldProps, _excluded3);
  return inputProps;
};
var useFormInputValidationProps = exports.useFormInputValidationProps = function useFormInputValidationProps(id) {
  var field = useFieldValidationSchema(id);
  if (!field) {
    return;
  }
  var tests = field.tests,
    type = field.type;
  var required = 'optional' in field ? !field.optional : undefined,
    integer,
    positive,
    min,
    max;
  tests === null || tests === void 0 || tests.forEach(function (_ref2) {
    var name = _ref2.name,
      params = _ref2.params;
    switch (name) {
      case 'required':
        required !== null && required !== void 0 ? required : required = true;
        break;
      case 'integer':
        integer = true;
        break;
      case 'positive':
        positive = true;
        break;
      case 'min':
        min = params;
        break;
      case 'max':
        max = params;
        break;
    }
  });
  return _objectSpread({
    required: required
  }, type === 'number' ? _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, integer && {
    step: 1
  }), positive && {
    min: 0
  }), min), max) : _objectSpread({}, max && {
    maxLength: max.max
  }));
};
function useFieldValidationSchema(id) {
  var _useFormContext2 = (0, _HBFormProvider.useFormContext)(),
    validationSchema = _useFormContext2.validationSchema;
  if (!validationSchema) {
    return;
  }
  var key = 'fields';
  return (0, _lodash.get)(validationSchema[key], id.split('.').join(".".concat(key, ".")));
}
//# sourceMappingURL=useFormFieldProps.js.map